module.exports = __webpack_public_path__ + "static/img/img_login_code.de72fd61.png";